import { Grid,TextField,Icon,Button, InputAdornment,Snackbar } from "@material-ui/core"
import { useSettings } from "./SettingsProvider"
import { Alert } from "@material-ui/lab";
const DatosEmpresa = () => {

    const {datosEmpresa,snack,setSnack, Guardar,handleOnchange} = useSettings()
  return (
      <>
      <Snackbar anchorOrigin={{horizontal:"center",vertical:"top"}} open={snack} onClose={()=>{setSnack(false)}} autoHideDuration={3000} >
        <Alert severity="success">Actualizado correctamente!</Alert>
        </Snackbar>
    <Grid container spacing={2} >
        <Grid item xs={12} sm={6}>
            <TextField
                autoFocus 
                label="Nombre de empresa"
                variant="outlined"
                fullWidth
                helperText="Fulanito de tal SRL"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon color="primary">info</Icon>
                      </InputAdornment>
                    ),
                  }}
                value={datosEmpresa.nombre_empresa}
                onChange={handleOnchange}
                name="nombre_empresa"
            />
        </Grid>
        <Grid item xs={12} sm={6}>
            <TextField 
                label="Propietario de empresa"
                variant="outlined"
                fullWidth
                helperText="Caso ser unipersonal, sino deje en blanco"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon color="primary">business_center</Icon>
                      </InputAdornment>
                    ),
                  }}
                  value={datosEmpresa.propietario_empresa}
                  onChange={handleOnchange}
                  name="propietario_empresa"
            />
        </Grid>
        <Grid item xs={12} sm={6}>
            <TextField 
                label="Ruc de empresa"
                variant="outlined"
                fullWidth
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon color="primary">credit_card</Icon>
                      </InputAdornment>
                    ),
                  }}
                  value={datosEmpresa.ruc_empresa}
                  onChange={handleOnchange}
                  name="ruc_empresa"
            />
        </Grid>
        <Grid item xs={12} sm={6}>
            <TextField 
                label="Dirección de empresa"
                variant="outlined"
                fullWidth
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon color="primary">push_pin</Icon>
                      </InputAdornment>
                    ),
                  }}
                value={datosEmpresa.direccion_empresa}
                onChange={handleOnchange}
                name="direccion_empresa"
            />
        </Grid>
        <Grid item xs={12} sm={6}>
            <TextField 
                label="Teléfono de empresa"
                variant="outlined"
                fullWidth
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon color="secondary">phone</Icon>
                      </InputAdornment>
                    ),
                  }}
                  value={datosEmpresa.telefono_empresa}
                  onChange={handleOnchange}
                  name="telefono_empresa"
            />
        </Grid>
        <Grid item xs={12} >
            <Button size="large" onClick={Guardar} variant="outlined" color="primary" startIcon={<Icon color="primary" >save</Icon>} >
                Guardar
            </Button>
        </Grid>
    </Grid>

    </>
  )
}

export default DatosEmpresa
